import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { buttonAnim, clickAnim } from "./ComicButton.anim";
import style from "./ComicButton.module.css";

interface ComicButtonProps {
    buttonName: React.ReactNode;
    hoverBtnName: React.ReactNode;
    btnClassName?: string;
    handleButtonClick?: () => void;
}

const randomNo = (min: number, max: number): number => {
    return min + Math.floor(Math.random() * (max - min));
};

const ComicButton: React.FC<ComicButtonProps> = ({
    buttonName,
    hoverBtnName,
    btnClassName = "",
    handleButtonClick,
}) => {
    const [btnName, setBtnName] = useState<React.ReactNode>(buttonName);

    // Actualiza el estado cuando cambie buttonName (por ejemplo, al cambiar el idioma)
    useEffect(() => {
        setBtnName(buttonName);
    }, [buttonName]);

    return (
        <motion.button
            type="button"
            className={style.btn + " " + btnClassName}
            initial="init"
            animate="init"
            whileHover="hover"
            whileTap="tap"
            whileFocus="focus"
            variants={buttonAnim}
            custom={randomNo(6, 12)}
            onMouseEnter={() => setBtnName(hoverBtnName)}
            onMouseLeave={() => setBtnName(buttonName)}
            onClick={handleButtonClick}
        >
            {btnName}
            <motion.div
                className={style.click}
                variants={clickAnim}
                custom={randomNo(-50, 50)}
            ></motion.div>
        </motion.button>
    );
};

export default ComicButton;
